import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0f3a955e")

_pushScopeId("data-v-0f3a955e")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Tasks")
const _hoisted_2 = {
  key: 0,
  class: "loading_spinner"
}
const _hoisted_3 = {
  key: 1,
  class: "page_content"
}
const _hoisted_4 = {
  key: 0,
  class: "no_tasks_container"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "no_tasks" }, "Nessuna task da visualizzare", -1)
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "tasks_container" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "title" }
const _hoisted_10 = { class: "project" }
const _hoisted_11 = { class: "badge_container" }
const _hoisted_12 = {
  key: 1,
  class: "no_selected_tasks"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ion_title = _resolveComponent("ion-title")
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_buttons = _resolveComponent("ion-buttons")
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")
  const _component_ion_header = _resolveComponent("ion-header")
  const _component_ion_spinner = _resolveComponent("ion-spinner")
  const _component_Calendar = _resolveComponent("Calendar")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_header, { translucent: true }, {
        default: _withId(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withId(() => [
              _createVNode(_component_ion_title, { color: "white" }, {
                default: _withId(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, {
                onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.openMenu())),
                slot: "start"
              }, {
                default: _withId(() => [
                  _createVNode(_component_ion_button, null, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        icon: $setup.menu,
                        slot: "start"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, { slot: "end" }, {
                default: _withId(() => [
                  _createVNode(_component_ion_button, {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.loadTasks()))
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        slot: "start",
                        icon: $setup.refresh,
                        color: "white"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withId(() => [
          ($setup.loading)
            ? (_openBlock(), _createBlock("div", _hoisted_2, [
                _createVNode(_component_ion_spinner, {
                  name: "crescent",
                  color: "dark"
                })
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_3, [
                (!$setup.tasks.length)
                  ? (_openBlock(), _createBlock("div", _hoisted_4, [
                      _hoisted_5
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_6, [
                      _createVNode("div", null, [
                        _createVNode("div", _hoisted_7, [
                          _createVNode(_component_Calendar, {
                            value: $setup.date,
                            "is-expanded": "",
                            attributes: $setup.setAttributes,
                            "disabled-dates": { weekdays: [1, 7] },
                            onDayclick: $setup.dayClicked,
                            class: "calendar_container"
                          }, null, 8, ["value", "attributes", "onDayclick"]),
                          ($setup.tasksToShow.length != 0)
                            ? (_openBlock(), _createBlock("div", _hoisted_8, [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.tasksToShow, (task) => {
                                  return (_openBlock(), _createBlock("div", {
                                    key: task.tasks_id,
                                    style: {
                                        borderLeft: `4px solid ${task.tasks_status_color}`,
                                    },
                                    onClick: ($event: any) => ($setup.openDetail(task)),
                                    class: "task"
                                  }, [
                                    _createVNode("div", _hoisted_9, "#" + _toDisplayString(task.tasks_id) + " - " + _toDisplayString(task.tasks_title), 1),
                                    _createVNode("div", _hoisted_10, _toDisplayString(task.projects_name ? task.projects_name : ""), 1),
                                    _createVNode("div", _hoisted_11, [
                                      _createVNode("div", {
                                        class: ["badge", $setup.taskPriority(task.tasks_priority)]
                                      }, _toDisplayString(task.tasks_priority_value ? task.tasks_priority_value : "-"), 3)
                                    ])
                                  ], 12, ["onClick"]))
                                }), 128))
                              ]))
                            : (_openBlock(), _createBlock("div", _hoisted_12, " Nessuna task assegnata per il " + _toDisplayString($setup.selectedDay ? $setup.dateFormat($setup.selectedDay.id) : $setup.dateFormat($setup.date)), 1))
                        ])
                      ])
                    ]))
              ]))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})